import BackButton from './BackButton';

interface Props {
  children: React.ReactNode;
}

const PageWrapper = ({ children }: Props) => {
  return (
    <div className="relative">
      <div className="absolute hidden md:block">
        <div className="flex h-7 w-7 items-center justify-center rounded-wt transition-all">
          <BackButton />
        </div>
      </div>

      <div className="mx-auto max-w-2xl">{children}</div>
    </div>
  );
};

export default PageWrapper;
